import React from "react";
import {Input, InputGroup, InputGroupText} from "reactstrap";
import {SearchIcon} from "./icons";

/**
 * A search field with a magnifier and a clear button. Controlled; the page
 * decides when to act on the text (e.g. after a pause in typing).
 *
 * @param {{
 *   value: string,
 *   onChange: (value: string) => void,
 *   placeholder?: string,
 *   ariaLabel?: string,
 * }} props
 */
const SearchBox = ({value, onChange, placeholder = "Buscar", ariaLabel = "Buscar"}) => (
    // An input group is 100% wide by default, which would push it onto a line
    // of its own: size it to sit beside other controls, shrinking if needed.
    <InputGroup className="flex-nowrap" style={{width: "auto", flex: "1 1 240px", maxWidth: 360}}>
        <InputGroupText className="bg-white border-primary text-primary">
            <SearchIcon />
        </InputGroupText>
        <Input
            // our own clear button below; the browser's differs per browser
            type="text"
            // same blue outline as the Filtrar button next to it
            className="border-primary"
            autoComplete="off"
            aria-label={ariaLabel}
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            onKeyDown={(event) => {
                if (event.key === "Escape" && value) onChange("");
            }}
        />
        {value && (
            <button
                type="button"
                className="btn btn-outline-primary"
                aria-label="Limpar busca"
                title="Limpar busca"
                onClick={() => onChange("")}
            >
                ×
            </button>
        )}
    </InputGroup>
);

export default SearchBox;
